import { useSelector } from "react-redux";
import { useFetchTokens } from './useFetchTokens';

export const useTokens = ({ enabled = false }) => {
  const {
    cvCredits: availableTokens,
    cvTokensExpiringSoon,
    earliestExpiryDate
  } = useSelector((state) => state.credit);

  const isInitialLoad = availableTokens === null;

  const { refetch, isFetching } = useFetchTokens({ enabled: enabled || isInitialLoad });

  return {
    refetch,
    isFetching,
    availableTokens: availableTokens || 0,
    cvTokensExpiringSoon,
    earliestExpiryDate
  };
}